<template>
    <module-card :nextDisabled="nextDisabled">
        <p class="text-h6">{{ underwearPersonalityStatement }}</p>
        <p>Move the dot towards “Not me at all” or “Very much like me” depending on your preference.</p>
        <p class="text-h6 text-center selected-text">{{ choice === null ? '&nbsp;' : choices[choice] }}</p>
        <v-slider @change="sliderChange" v-model="sliderChoice" :max="4" step="1" track-color="primary" thumb-color="red" ticks="always" tick-size="5"></v-slider>
        <div class="arrow-container">
            <div class="arrow-label">Not me at all</div>
            <div class="arrow-wrapper">
                <div class="arrow middle"></div>
            </div>
            <div class="arrow-label">Very much like me</div>
        </div>
    </module-card>
</template>

<script>
    export default {
        data() {
            return {
                choices: ['Not me at all', 'Not really me', 'Somewhat like me', 'Like me', 'Very much like me']
            };
        },
        props: {
            statement: {
                type: Number,
                required: true
            }
        },
        computed: {
            // this is a bit ugly; the slider model is "sliderChoice", but the actual selected choice is "choice"
            // this allows us to put the thumb in the middle of the slider when no choice is actually selected
            choice() {
                let choice = this.$store.get(`underwearPersonality@${this.statement}.choice`);

                return choice;
            },
            sliderChoice: {
                get() {
                    // if the user has selected value for this statement already, we want to display that;
                    // but if not, we want no choice to be selected, but still but the slider thumb in the
                    // middle of the slider.
                    if (this.choice === null) {
                        return 2;
                    }
                    return this.choice;
                },
                // have to define a computed setter but don't actually want it to do anything; bypass lint
                // eslint-disable-next-line no-unused-vars
                set(v) {}
            },
            underwearPersonalityStatement() {
                return this.$store.get(`content@underwearPersonalityStatements[${this.statement}].statement`);
            }
        },
        methods: {
            nextDisabled() {
                return this.choice === null;
            },
            sliderChange(newValue) {
                this.$store.set(`underwearPersonality@${this.statement}.choice`, newValue);
            }
        }
    };
</script>

<style scoped>
    ::v-deep .v-slider__tick {
        background-color: var(--v-primary-base);
    }

    .selected-text {
        white-space: pre-wrap;
    }

    .arrow-label {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 85px;
    }

    .arrow-wrapper {
        display: flex;
        width: 100%;
        align-items: center;
    }

    .arrow-container {
        display: flex;
        padding: 0px;
    }
    .middle {
        flex-grow: 1;
    }

    .arrow {
        position: relative;
        margin: 12px 20px;
        height: 0;
        border-bottom: 1px dotted var(--v-primary-base);
    }

    .arrow::after {
        content: '';
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 12px solid var(--v-primary-base);
        position: absolute;
        right: -10px;
        top: -8px;
    }

    .arrow::before {
        content: '';
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 12px solid var(--v-primary-base);
        position: absolute;
        left: -10px;
        top: -8px;
    }
</style>
